export default {"src":"/_next/static/media/baked-pack-icon.1ef4f091.svg","height":35,"width":39,"blurWidth":0,"blurHeight":0};